export const defaultTimezoneKey = 'GMT0200';
export const defaultTimezoneRegionId = 'Europe/Berlin';
